// @ts-nocheck
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogistikaParastakita from './LogistikaParastakita';
import CompanyInfoSettings from './CompanyInfoSettings';
import BankReconciliation from './BankReconciliation';
import FinancialsSelect from './FinancialsSelect';
import EntitiesManager from './EntitiesManager';

type TabKey = 'parastatika' | 'trapezikes' | 'oikonomika' | 'rythmiseis' | 'mydata';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'parastatika', label: 'Παραστατικά' },
  { key: 'trapezikes',  label: 'Τραπεζικές Πληρωμές' },
  { key: 'oikonomika', label: 'Οικονομικά Σκαφών' },
  { key: 'rythmiseis', label: 'Ρυθμίσεις' },
  { key: 'mydata',     label: 'myDATA' },
];

const LogistikaPage: React.FC = () => {
  const reactNavigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabKey>('parastatika');

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', padding: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
        <button
          onClick={() => reactNavigate('/admin')}
          style={{
            padding: '8px 16px',
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: 6,
            cursor: 'pointer',
            marginRight: 16,
          }}
        >
          ← Πίσω
        </button>
        <h1 style={{ margin: 0, fontSize: 24 }}>ΛΟΓΙΣΤΙΚΑ</h1>
      </div>

      <div style={{ display: 'flex', gap: 8, borderBottom: '2px solid #e0e0e0', marginBottom: 20 }}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: activeTab === tab.key ? '#1976d2' : 'transparent',
              color: activeTab === tab.key ? '#fff' : '#333',
              cursor: 'pointer',
              borderRadius: '6px 6px 0 0',
              fontWeight: activeTab === tab.key ? 600 : 400,
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div style={{ background: activeTab === 'parastatika' ? 'transparent' : '#fff', padding: activeTab === 'parastatika' ? 0 : 30, borderRadius: 8, minHeight: 400 }}>
        {activeTab === 'parastatika' && <LogistikaParastakita />}
        {activeTab === 'trapezikes' && <BankReconciliation />}
        {activeTab === 'oikonomika' && <FinancialsSelect />}
        {activeTab === 'rythmiseis' && (
          <div>
            <CompanyInfoSettings />
            <EntitiesManager />
            <p style={{ color: '#888', marginTop: 24 }}>Σειρές παραστατικών, πελάτες, προμηθευτές. Coming soon.</p>
          </div>
        )}
        {activeTab === 'mydata' && (
          <div>
            <h2>myDATA</h2>
            <p style={{ color: '#888' }}>ΑΑΔΕ integration. Future.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogistikaPage;
